import React from 'react';
import Icon from '../../../components/AppIcon';

const RevisionHistory = ({ revisions }) => {
  const getRevisionIcon = (type) => {
    switch (type) {
      case 'created':
        return 'Plus';
      case 'ai_generated':
        return 'Bot';
      case 'revision_requested':
        return 'MessageSquare';
      case 'completed':
        return 'CheckCircle';
      case 'updated':
        return 'Edit';
      default:
        return 'Clock';
    }
  };

  const getRevisionColor = (type) => {
    switch (type) {
      case 'created':
        return 'text-primary bg-primary/10';
      case 'ai_generated':
        return 'text-accent bg-accent/10';
      case 'revision_requested':
        return 'text-warning bg-warning/10';
      case 'completed':
        return 'text-success bg-success/10';
      case 'updated':
        return 'text-secondary bg-secondary/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const formatPersianDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fa-IR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })?.format(date);
  };

  if (!revisions || revisions?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 card-shadow">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="History" size={20} className="text-primary" />
          <h2 className="text-lg font-semibold text-foreground">
            تاریخچه تغییرات
          </h2>
        </div>

        <div className="flex items-center justify-center h-32">
          <div className="text-center">
            <Icon
              name="Clock"
              size={32}
              className="text-muted-foreground mx-auto mb-2"
            />
            <p className="text-muted-foreground">
              هیچ تاریخچه‌ای برای این درخواست ثبت نشده است
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border card-shadow">
      <div className="border-b border-border p-4">
        <div className="flex items-center gap-2">
          <Icon name="History" size={20} className="text-primary" />
          <h2 className="text-lg font-semibold text-foreground">
            تاریخچه تغییرات
          </h2>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          تمام مراحل پردازش و تغییرات این درخواست
        </p>
      </div>
      <div className="p-4">
        <div className="space-y-4">
          {revisions?.map((revision, index) => (
            <div key={revision?.id} className="flex gap-4">
              {/* Timeline Line */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center ${getRevisionColor(
                    revision?.type
                  )}`}>
                  <Icon name={getRevisionIcon(revision?.type)} size={18} />
                </div>
                {index < revisions?.length - 1 && (
                  <div className="w-0.5 h-8 bg-border mt-2"></div>
                )}
              </div>

              {/* Content */}
              <div className="flex-1 pb-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-foreground">
                    {revision?.title}
                  </h3>
                  <span className="text-sm text-muted-foreground">
                    {formatPersianDate(revision?.timestamp)}
                  </span>
                </div>

                <p className="text-muted-foreground text-sm leading-relaxed mb-2">
                  {revision?.description}
                </p>

                {revision?.feedback && (
                  <div className="bg-muted/50 rounded-lg p-3 mt-2">
                    <div className="flex items-start gap-2">
                      <Icon
                        name="MessageCircle"
                        size={16}
                        className="text-primary mt-0.5"
                      />
                      <div>
                        <p className="text-sm font-medium text-foreground mb-1">
                          بازخورد کاربر:
                        </p>
                        <p className="text-sm text-muted-foreground">
                          {revision?.feedback}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {revision?.aiResponse && (
                  <div className="bg-accent/5 border border-accent/20 rounded-lg p-3 mt-2">
                    <div className="flex items-start gap-2">
                      <Icon
                        name="Bot"
                        size={16}
                        className="text-accent mt-0.5"
                      />
                      <div>
                        <p className="text-sm font-medium text-foreground mb-1">
                          پاسخ هوش مصنوعی:
                        </p>
                        <p className="text-sm text-muted-foreground">
                          {revision?.aiResponse}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RevisionHistory;
